// Real (already grayscale / white-on-transparent) brand assets, keyed by slug.
export const IMAGES = {
  crest: "/assets/crest.png",
  wordmark: "/assets/wordmark.png",
  founder: "/assets/founder.jpg",
  wine: "/assets/wine.jpg",
  head: "/assets/head.jpg",
  sculpture: "/assets/sculpture.jpg",
  figures: "/assets/figures.jpg",
  "mask-black": "/assets/mask-black.jpg",
  headdress: "/assets/headdress.jpg",
  "mask-baule": "/assets/mask-baule.jpg",
  "mask-dan": "/assets/mask-dan.jpg",
};
